import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import IconFrom from "../../assets/v2/map-pin.png";
import IconTo from "../../assets/v2/goal.png";
import Dot from "../../assets/v2/dot.png";
import useValetStore from "./hooks/useValetStore";
import Swal from "sweetalert2";
import RadioSelector from "../../components/v2/RadioSelector";
import {RouteType} from "./constants/RouteType";
import {AccountType} from "../../constants/AccountType";
import {ValetSteps} from "./constants/ValetSteps";
import {KucPhoneTextField} from "../../components/common/KucPhoneTextField";
import KucPhoneInput from "../../components/v2/KucPhoneInput";
import Alert, {ERROR, SUCCESS} from "../../components/v2/Alert";
import {useTranslation} from "react-i18next";

export default function ValetYourIdentity({
                                              backClickedHandler
                                          }) {

    const {
        callPost,
        userData,
        setIdentityData,
        setStep
    } = useValetStore();

    const [isCompany, setIsCompany] = useState((userData.identity.company !== null && userData.identity.company !== ''));
    const [company, setCompany] = useState(userData?.identity?.company ?? '');
    const [lastName, setLastName] = useState(userData?.identity?.last_name ?? '');
    const [firstName, setFirstName] = useState(userData?.identity?.first_name ?? '');
    const [email, setEmail] = useState(userData?.email ?? '');

    const [phone, setPhone] = useState(userData?.identity?.phone ?? '');
    const [validPhone, setValidPhone] = useState();

    const [errorMessage, setErrorMessage] = useState(null);

    const formRef = React.useRef();

    const {t} = useTranslation('common');

    const nextClickedHandler = (e) => {
        if (!formRef.current.reportValidity()) {
            return;
        }

        if (validPhone === false) {
            setErrorMessage(t('valet.identity.text'));
            return;
        }

        setErrorMessage(null);

        callPost('account_details', {
            'last_name': lastName,
            'first_name': firstName,
            'phone': phone,
            'company': company
        }, (data) => {
            setIdentityData(
                {
                    last_name: lastName,
                    first_name: firstName,
                    phone: phone,
                    company: company
                }
            )
            setStep(
                ValetSteps.YOUR_ORDER
            );
        }, (failResultData) => {
            Swal.fire({
                text: failResultData.message,
                icon: 'error',
            });
        });
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={60}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.identity.text2')}
        </div>
        <form ref={formRef}>


            <RadioSelector version={"button"} id={"route_type"} value={isCompany} values={[
                {value: false, label: t('valet.identity.text3')},
                {value: true, label: t('valet.identity.text4')},
            ]} onChange={(value) => setIsCompany(value)}/>

            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('valet.identity.text5')}&nbsp;</legend>
                {isCompany &&
                    <Input id="company" label={t('valet.identity.text6')}
                           placeholder={t('valet.identity.text18')}
                           value={company}
                           onChange={(e) => setCompany(e)}
                           required={true}
                    />
                }
                <Input id="last_name" label={t('valet.identity.text7')} placeholder={t('valet.identity.text8')}
                       value={lastName}
                       onChange={(e) => setLastName(e)}
                       required={true}
                />
                <Input id="first_name" label={t('valet.identity.text9')} placeholder={t('valet.identity.text10')}
                       value={firstName}
                       onChange={(e) => setFirstName(e)}
                       required={true}
                />
            </fieldset>

            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('valet.identity.text11')}&nbsp;</legend>
                <Input id="email" label={t('valet.identity.text12')}
                       placeholder={t('valet.identity.text13')}
                       value={email}
                       disabled={true}
                />
                {/*<Input id="phone" label="Numéro de téléphone" placeholder="Exemple : 06.12.34.56.78"*/}
                {/*       value={phone}*/}
                {/*       onChange={(e) => setPhone(e)}*/}
                {/*       required={true}*/}
                {/*/>*/}

                <KucPhoneInput
                    variant={'outlined'}
                    margin="normal"
                    required={true}
                    fullWidth
                    id="phone"
                    name="phone"
                    label={t('valet.identity.text14')}
                    value={phone}
                    onChange={(value, isValid) => {
                        setPhone(value);
                        setValidPhone(isValid);
                    }}
                />

            </fieldset>
        </form>

        {errorMessage ?
            <Alert type={ERROR}
                   text={errorMessage}
            />
            : null}

        <div className="grow">
        </div>
        <div className="flex gap-4">
            <Button outline text={<div>
                <div>{t('valet.identity.text15')}</div>
                <div className="text-sm mt-[-8px]">{t('valet.identity.text16')}</div>
            </div>} clickHandler={backClickedHandler}/>
            <Button text={t('valet.identity.text17')} clickHandler={nextClickedHandler}/>
        </div>
    </div>
}